<template>
  <div class="new-report">
    <div class="report-header">
      <!-- Added back button -->
      <div class="heads">
        <span
          class="btn new-content-data-item-toggle-circle"
          @click="cancelReport()"
        >
          <span class="tms">e</span>
        </span>
        <h2 v-if="this.$route.name === 'newReport'" class="title">
          Създай отчет на база планираното
        </h2>
        <h2 v-if="this.$route.name === 'editReport'" class="title">
          {{ $t("edit-report") }}
          <span v-if="report.isInvalid">
            (
            <img class="flag" src="../assets/img/flag_yes.svg" alt="Valid" />
            {{ $t("invalid-report") }})
          </span>
        </h2>
      </div>

      <div
        v-if="this.$route.name === 'editReport' && !saving"
        class="locked-state locked-state--text-only"
        :class="{ 'locked-state--locked': report.locked }"
      >
        <strong>
          {{ `Отчетът ${report.locked ? "не" : ""} може да бъде редактиран` }}
        </strong>
        <span v-if="report.locked">
          За да бъде редактиран, трябва да се отключи от Гл. Админ
        </span>
        <span v-else>
          *само от Гл.админ, админ или създател -
          {{ report.createdBy.name }}
        </span>
      </div>

      <!-- NEW REPORT BUTTONS DESKTOP-->
      <div class="btns" v-if="allowSave">
        <!-- <div
          @click="
            getUser.permissions.isSuperAdmin
              ? (report.locked = !report.locked)
              : null
          "
          v-if="this.$route.name === 'editReport' && !saving"
          class="locked-state"
          :class="{ 'locked-state--locked': report.locked }"
        >
          <span class="tms"> {{ report.locked ? "%" : "&" }}</span>
        </div> -->
        <button
          class="btn btn-unlock desktop"
          v-if="canLockOrUnlock"
          @click="
            canLockOrUnlock ? ((report.locked = !report.locked), save()) : null
          "
        >
          <span class="tms">&amp;</span>
          {{ report.locked ? "Отключи" : "Приключи" }} отчет
        </button>
        <button class="btn btn-close desktop" @click="cancelReport()">
          <span class="tms">F</span>
          {{ saving ? $t("close") : $t("cancel") }}
        </button>
        <button
          v-if="canSaveReport"
          class="btn btn-new desktop"
          @click="save()"
        >
          <span class="tms">Y</span>
          {{ $t("save") }}
        </button>
      </div>
    </div>
    <!-- NEW REPORT CONTENT -->
    <div
      class="new-wrapper"
      :class="{ 'new-wrapper-invalid': report.isInvalid }"
    >
      <div class="new-content">
        <!-- ROW 1 DESKTOP -->
        <!-- <div class="new-content-inputs desktop">
          DATE
          <div class="new-input-wrapper">
            <label for="newReportDate">{{ $t('date') | capitalize }}</label>
            <div class="new-input">
              <span class="tms">D</span>
              <input
                class="date"
                type="text"
                id="newReportDate"
                @click="openDropdown(0)"
                @focus="openDropdown(0)"
                @blur="closeDropdown(0)"
                :placeholder="$t('date') | capitalize"
                v-model="formatedDate"
                :disabled="this.$route.name === 'editReport'"
                readonly
              />
              <span v-if="this.$route.name === 'editReport'" class="disabled">A</span>
            </div>
            <div
              class="new-input-dropdown datepicker-dropdown"
              :class="{ 'datepicker-dropdown-active' : openedDropdown[0] }"
            >
              <datepicker
                :language="bg"
                :inline="true"
                :monday-first="true"
                :wrapper-class="'custom-datepicker'"
                :calendar-class="'custom-calendar'"
                v-model="report.date"
                @selected="closeDropdown(0), reportChanged()"
              ></datepicker>
            </div>
          </div> -->
        <!-- START HOUR -->
        <!-- <div class="new-input-wrapper">
            <label for="newReportStartHour">{{ $t('hour-start') }}</label>
            <div class="new-input">
              <span class="tms">R</span>
              <input
                type="text"
                id="newReportStartHour"
                v-model="report.startHour"
                @focus="openDropdown(1)"
                @blur="closeDropdown(1)"
                :disabled="!allowSave"
              />
              <span v-if="!allowSave" class="disabled">A</span>
            </div>
            <div
              class="new-input-dropdown"
              :class="{ 'new-input-dropdown-active' : openedDropdown[1] }"
            >
              <ul>
                GETTING HOURS FROM THE MIXIN
                <li
                  v-for="hour in hours"
                  :key="`startHour-${hour}`"
                  @click="report.startHour = hour, reportChanged()"
                >{{hour}}</li>
              </ul>
            </div>
          </div> -->
        <!-- END HOUR -->
        <!-- <div class="new-input-wrapper">
            <label for="newReportEndHour">{{ $t('hour-end') }}</label>
            <div class="new-input">
              <span class="tms">R</span>
              <input
                type="text"
                id="newReportEndHour"
                v-model="report.endHour"
                @focus="openDropdown(2)"
                @blur="closeDropdown(2)"
                :disabled="!allowSave"
              />
              <span v-if="!allowSave" class="disabled">A</span>
            </div>
            <div
              class="new-input-dropdown"
              :class="{ 'new-input-dropdown-active' : openedDropdown[2] }"
            >
              <ul>
                GETTING HOURS FROM THE MIXIN
                <li
                  v-for="hour in hours"
                  :key="`startHour-${hour}`"
                  @click="report.endHour = hour, reportChanged()"
                >{{hour}}</li>
              </ul>
            </div>
          </div> -->
        <!-- ИРВ 2 -->
        <!-- <div class="new-input-wrapper">
            <label for="newReportOvertime">{{ $t('working-time-type') }}</label>
            <div class="new-input indicator-display">
              <span class="tms">R</span>
              <p>{{calculateHours(report.date, report.startHour, report.endHour).total}} ч.</p>
              <div class="indicators">
                <span
                  class="worktime-indicator"
                  :class="{ 'indicator-inactive' : !calculateHours(report.date, report.startHour, report.endHour).normal }"
                >
                  <span>{{ $t('working-time-normal') }}</span>
                </span>
                <span
                  class="worktime-indicator overtime-indicator"
                  :class="{ 'indicator-inactive' : !calculateHours(report.date, report.startHour, report.endHour).overtime }"
                >
                  <span>{{ $t('working-time-overtime-1') }}</span>
                </span>
                <span
                  class="worktime-indicator holiday-indicator"
                  :class="{ 'indicator-inactive' : !calculateHours(report.date, report.startHour, report.endHour).holiday }"
                >
                  <span>{{ $t('working-time-overtime-2') }}</span>
                </span>
              </div>
              <label class="checkbox-wrapper">
                ИРВ 2
                <input
                  type="checkbox"
                  v-model="report.overtime"
                  id="newReportOvertime"
                  @change="reportChanged()"
                >
                <span class="checkmark" :class="{ 'checkmark-red' : report.overtime}"></span>
              </label>
            </div>
          </div> -->
        <!-- </div> -->
        <!-- ROW 1 MOBILE -->
        <!-- <div class="new-content-inputs mobile">
          <div class="date-irv-wrapper mobile"> -->
        <!-- Date -->
        <!-- <div class="new-input-wrapper">
              <div class="new-input">
                <span class="tms">D</span>
                <input
                  class="date"
                  type="text"
                  id="newReportDate"
                  @click="openDropdown(0)"
                  @focus="openDropdown(0)"
                  @blur="closeDropdown(0)"
                  :placeholder="$t('hour-end') | capitalize"
                  v-model="formatedDate"
                  :disabled="this.$route.name === 'editReport'"
                  readonly
                />
                <span v-if="this.$route.name === 'editReport'" class="disabled">A</span>
              </div>
              <div
                class="new-input-dropdown datepicker-dropdown"
                :class="{ 'datepicker-dropdown-active' : openedDropdown[0] }"
              >
                <datepicker
                  :language="bg"
                  :inline="true"
                  :monday-first="true"
                  :wrapper-class="'custom-datepicker'"
                  :calendar-class="'custom-calendar'"
                  v-model="report.date"
                  @selected="closeDropdown(0), reportChanged()"
                ></datepicker>
              </div>
            </div> -->

        <!-- ИРВ 2 -->
        <!-- <div class="new-input-wrapper">
              <div class="new-input indicator-display">
                <span class="tms">R</span>
                <p>{{calculateHours(report.date, report.startHour, report.endHour).total}} ч.</p>
                <div class="indicators">
                  <span
                    class="worktime-indicator"
                    :class="{ 'indicator-inactive' : !calculateHours(report.date, report.startHour, report.endHour).normal }"
                  >
                    <span>{{ $t('working-time-normal') }}</span>
                  </span>
                  <span
                    class="worktime-indicator overtime-indicator"
                    :class="{ 'indicator-inactive' : !calculateHours(report.date, report.startHour, report.endHour).overtime }"
                  >
                    <span>{{ $t('working-time-overtime-1') }}</span>
                  </span>
                  <span
                    class="worktime-indicator holiday-indicator"
                    :class="{ 'indicator-inactive' : !calculateHours(report.date, report.startHour, report.endHour).holiday }"
                  >
                    <span>{{ $t('working-time-overtime-2') }}</span>
                  </span>
                </div>
                <input type="checkbox" id="newReportDate" @focus="openDropdown(3)" @blur="closeDropdown(3)">
                <label class="checkbox-wrapper">
                  ИРВ 2
                  <input
                    type="checkbox"
                    v-model="report.overtime"
                    id="newReportOvertime"
                    @change="reportChanged()"
                  >
                  <span class="checkmark" :class="{ 'checkmark-red' : report.overtime}"></span>
                </label>
              </div>
            </div> -->
        <!-- </div> -->

        <!-- <div class="start-end-wrapper"> -->
        <!-- START HOUR -->
        <!-- <div class="new-input-wrapper">
              <div class="new-input mobile">
                <span class="tms">R</span>
                <select
                  class="select"
                  v-model="report.startHour"
                  @change="reportChanged()"
                  :disabled="!allowSave"
                >
                  {{report.startHour}}">
                  <option :value="hour" v-for="hour in hours" :key="`startHour-${hour}`">{{hour}}</option>
                </select>
                <span v-if="!allowSave" class="disabled">A</span>
              </div>
            </div> -->
        <!-- END HOUR -->
        <!-- <div class="new-input-wrapper">
              <div class="new-input mobile">
                <span class="tms">R</span>
                <select
                  class="select"
                  v-model="report.endHour"
                  @change="reportChanged()"
                  :disabled="!allowSave"
                >
                  {{report.startHour}}">
                  <option :value="hour" v-for="hour in hours" :key="`endHour-${hour}`">{{hour}}</option>
                </select>
                <span v-if="!allowSave" class="disabled">A</span>
              </div>
            </div> -->
        <!-- </div> -->
        <!-- </div> -->

        <!-- ROW 2 DESKTOP AND MOBILE  -->
        <div class="new-content-inputs">
          <!-- DATE -->
          <div class="new-input-wrapper">
            <!-- <label for="newReportDate">{{ $t("date") | capitalize }}</label> -->
            <div class="new-input">
              <span class="tms">D</span>
              <input
                class="date"
                type="text"
                id="newReportDate"
                @click="openDropdown(0)"
                @focus="openDropdown(0)"
                @blur="closeDropdown(0)"
                :placeholder="$t('date') | capitalize"
                v-model="formatedDate"
                :disabled="this.$route.name === 'editReport'"
                readonly
              />
              <span v-if="this.$route.name === 'editReport'" class="disabled"
                >A</span
              >
            </div>
            <div
              class="new-input-dropdown datepicker-dropdown"
              :class="{ 'datepicker-dropdown-active': openedDropdown[0] }"
            >
              <datepicker
                :language="bg"
                :inline="true"
                :monday-first="true"
                :wrapper-class="'custom-datepicker'"
                :calendar-class="'custom-calendar'"
                v-model="report.date"
                @selected="closeDropdown(0), reportChanged()"
              ></datepicker>
            </div>
          </div>
          <!-- DESKTOP COMPANY -->
          <div class="new-input-wrapper desktop">
            <!-- <label class="desktop">{{ $t("company") }}</label> -->
            <div
              class="new-input"
              :class="{
                'new-input-disabled': this.$route.name === 'editReport',
              }"
            >
              <span class="tms">Z</span>
              <!-- NOT SELECTED -->
              <input
                v-if="!report.company._id.length"
                type="text"
                :placeholder="$t('company-name')"
                @focus="getCompanies(), openDropdown(3)"
                @blur="closeDropdown(3)"
                v-model="searchCompanies"
                :disabled="this.$route.name === 'editReport'"
              />
              <!-- SELECTED -->
              <input
                v-else
                type="text"
                :placeholder="$t('company-name')"
                @focus="getCompanies(), openDropdown(3)"
                v-model="report.company.companyName"
                @blur="closeDropdown(3)"
                :disabled="
                  this.$route.name === 'editReport' || report.company._id.length
                "
              />
              <span
                v-if="
                  report.company._id.length && this.$route.name !== 'editReport'
                "
                class="clear"
                @click="resetSelectedCompany()"
                >F</span
              >
              <span v-if="this.$route.name === 'editReport'" class="disabled"
                >A</span
              >
            </div>
            <!-- DROP-DOWN COMPANIES -->
            <div
              class="new-input-dropdown"
              :class="{ 'new-input-dropdown-active': openedDropdown[3] }"
            >
              <ul v-if="companies.length">
                <li
                  v-for="c in filteredCompanies()"
                  :key="c._id"
                  @mousedown="selectCompany(c), reportChanged(), closeDropdown(3)"
                >
                  {{ c.companyName }}
                </li>
              </ul>
            </div>
          </div>
          <!-- MOBILE COMPANY -->
          <label class="label mobile" for="company">{{ $t("company") }}</label>
          <div class="new-input mobile">
            <span class="tms">Z</span>
            <!-- NOT SELECTED -->
            <select
              v-if="!report.company._id.length"
              id="company"
              class="select"
              v-model="company"
              @change="selectCompany(company), getObjects(), reportChanged()"
            >
              <option value disabled hidden v-if="$route.name !== 'editReport'">
                {{ $t("company-name") }}
              </option>
              <option
                :value="`${$t('last-companies')}:`"
                v-if="$route.name !== 'editReport'"
                disabled
              >
                {{ $t("last-companies") }}:
              </option>
              <template v-for="c in latestCompanies">
                <option
                  :value="c"
                  v-if="$route.name !== 'editReport'"
                  :key="`latestCompanies-${c._id}`"
                  selected
                >
                  {{ c.companyName }}
                </option>
              </template>
              <option value v-if="$route.name !== 'editReport'" disabled>
                {{ $t("all-companies") }}:
              </option>
              <template v-for="(c, index) in companies">
                <option
                  v-if="companies.length && $route.name !== 'editReport'"
                  :value="c"
                  :key="index"
                  selected
                >
                  {{ c.companyName }}
                </option>
              </template>
              <option
                :value="report.company"
                v-if="this.$route.name === 'editReport'"
                selected
                disabled
              >
                {{ report.company.companyName }}
              </option>
            </select>
            <!-- SELECTED -->
            <input
              v-else
              type="text"
              :placeholder="$t('company-name')"
              v-model="report.company.companyName"
              :disabled="
                this.$route.name === 'editReport' || report.company._id.length
              "
            />
            <span
              v-if="
                report.company._id.length && this.$route.name !== 'editReport'
              "
              class="clear"
              @click="resetSelectedCompany()"
              >F</span
            >
            <span v-if="this.$route.name === 'editReport'" class="disabled"
              >A</span
            >
          </div>
          <!-- OBJECT -->
          <div class="new-input-wrapper desktop">
            <div
              class="new-input"
              :class="{
                'new-input-disabled': this.$route.name === 'editReport',
              }"
            >
              <span class="tms">Z</span>
              <!-- NOT SELECTED -->
              <input
                v-if="!report.object._id.length"
                type="text"
                :placeholder="$t('site-name')"
                @focus="getObjects(), openDropdown(5)"
                @blur="closeDropdown(5)"
                v-model="searchObjects"
                :disabled="this.$route.name === 'editReport'"
              />
              <!-- SELECTED -->
              <input
                v-else
                type="text"
                :placeholder="$t('site-name')"
                @focus="getObjects(), openDropdown(5)"
                @blur="closeDropdown(5)"
                v-model="report.object.objectName"
                :disabled="
                  this.$route.name === 'editReport' || report.object._id.length
                "
              />
              <span
                v-if="
                  report.object._id.length && this.$route.name !== 'editReport'
                "
                class="clear"
                @click="resetSelectedObject()"
                >F</span
              >
              <span v-if="this.$route.name === 'editReport'" class="disabled"
                >A</span
              >
            </div>
            <!-- DROP-DOWN OBJECTS -->
            <div
              class="new-input-dropdown"
              :class="{ 'new-input-dropdown-active': openedDropdown[5] }"
            >
              <ul v-if="objects.length">
                <li
                  v-for="o in filteredObjects()"
                  :key="o._id"
                  @mousedown="selectObject(o), closeDropdown(5)"
                >
                  {{ o.objectName }}
                </li>
              </ul>
            </div>
          </div>
          <!-- MOBILE OBJECT -->
          <label class="label mobile" for="object">{{ $t("site") }}</label>
          <div class="new-input mobile">
            <span class="tms">Z</span>
            <!-- NOT SELECTED -->
            <select
              v-if="!report.object._id.length"
              id="object"
              class="select"
              v-model="object"
              @change="selectObject(object), getParts()"
            >
              <option value disabled hidden>{{ $t("site-name") }}</option>
              <template v-for="(o, index) in objects">
                <option :value="o" :key="index">{{ o.objectName }}</option>
              </template>
            </select>
            <!-- SELECTED -->
            <input
              v-else
              type="text"
              :placeholder="$t('site-name')"
              v-model="report.object.objectName"
              :disabled="
                this.$route.name === 'editReport' || report.object._id.length
              "
            />

            <span
              v-if="
                report.object._id.length && this.$route.name !== 'editReport'
              "
              class="clear"
              @click="resetSelectedObject()"
              >F</span
            >
            <span v-if="this.$route.name === 'editReport'" class="disabled"
              >A</span
            >
          </div>
        </div>

        <!-- NEW USER BUTTONS MOBILE -->
        <div class="btns mobile" v-if="allowSave">
          <div class="btn-unlock--wrapper">
            <button
              class="btn btn-unlock"
              v-if="canLockOrUnlock"
              @click="
                canLockOrUnlock
                  ? ((report.locked = !report.locked), save())
                  : null
              "
            >
              <span class="tms">&amp;</span>
              {{ report.locked ? "Отключи" : "Приключи" }} отчет
            </button>
          </div>
          <button class="btn btn-close" @click="cancelReport()">
            <span class="tms">F</span>
            {{ saving ? $t("close") : $t("cancel") }}
          </button>
          <button class="btn btn-new" @click="save()">
            <span class="tms">Y</span>
            {{ $t("save") }}
          </button>
        </div>
      </div>
    </div>

    <template
      v-if="allowSave && (report.parts.length || $route.name === 'editReport')"
    >
      <div
        class="new-wrapper"
        :class="{ 'new-wrapper-invalid': report.isInvalid }"
        v-for="(p, i) in report.parts"
        :key="`rp-${i}`"
      >
        <!-- DESKTOP MATERIALS / ACTIVITIES / MECHANIZATIONS FIRST ROW SHOWN WHEN VIEW LISTS IS ACTIVE -->
        <header class="part-header">
          <div class="new-input-wrapper">
            <div class="new-input">
              <span class="tms">Z</span>
              <!-- NOT SELECTED -->
              <input
                v-if="!p.part._id.length"
                type="text"
                :placeholder="$t('part-name')"
                @focus="getParts(), $set(p, 'dropdown', true)"
                @blur="$delete(p, 'dropdown')"
                v-model="p.search"
              />
              <!-- SELECTED -->
              <input
                v-else
                type="text"
                :placeholder="$t('part-name')"
                @focus="getParts(), $set(p, 'dropdown', true)"
                @blur="$delete(p, 'dropdown')"
                v-model="p.part.partName"
                :disabled="p.part._id.length"
              />

              <template v-if="p.part && !viewLists(p)">
                <span
                  v-if="p.part._id.length"
                  class="clear"
                  @click="$set(p, 'part', { _id: '', partName: '' })"
                  >F</span
                >
              </template>
              <span v-if="viewLists(p)" class="disabled">A</span>
              <span
                v-if="p.part ? !p.part._id : true"
                class="bin"
                @click="removePart(i)"
                >b</span
              >
            </div>
            <!-- DROP-DOWN PARTS -->
            <div
              class="new-input-dropdown"
              :class="{ 'new-input-dropdown-active': p.dropdown }"
            >
              <ul v-if="parts.length">
                <li
                  v-for="fp in filteredParts(p.search)"
                  :key="fp._id"
                  @mousedown="selectPart(p, fp), $delete(p, 'dropdown')"
                >
                  {{ fp.partName }}
                </li>
              </ul>
            </div>
          </div>
          <div class="buttons">
            <button :disabled="!p.part._id" @click="openAddWorkersModal(p)">
              <span class="tms">V</span>
              <span>{{ $t("add-reporters") }}</span>
            </button>
            <button :disabled="!p.part._id" @click="openAddMaterialsModal(p)">
              <span class="tms">T</span>
              <span>{{ $t("add-materials") }}</span>
            </button>
            <button :disabled="!p.part._id" @click="openAddActivitiesModal(p)">
              <span class="tms">U</span>
              <span>{{ $t("add-activities") }}</span>
            </button>
          </div>
          <!-- <div class="new-content-data-item">
            <div
              class="new-content-data-item-toggle"
              @click="openAddWorkersModal()"
            >
              <p>{{ $t("add-reporters") }}</p>
              <span class="new-content-data-item-toggle-circle">
                <span class="tms">V</span>
              </span>
            </div>
          </div> -->
          <!-- DESKTOP MATERIALS -->
          <!-- <div class="new-content-data-item">
            <div
              class="new-content-data-item-toggle"
              @click="openAddMaterialsModal()"
            >
              <p>{{ $t("add-materials") }}</p>
              <span class="new-content-data-item-toggle-circle">
                <span class="tms">T</span>
              </span>
            </div>
          </div> -->
          <!-- DESKTOP ACTIVITIES -->
          <!-- <div class="new-content-data-item">
            <div
              class="new-content-data-item-toggle"
              @click="openAddActivitiesModal()"
            >
              <p>{{ $t("add-activities") }}</p>
              <span class="new-content-data-item-toggle-circle">
                <span class="tms">U</span>
              </span>
            </div>
          </div> -->
          <!-- DESKTOP MECHANIZATIONS -->
          <!-- <div
            class="new-content-data-item"
            v-if="selectedObject !== undefined || this.$route.name === 'editReport'"
          >
            <div class="new-content-data-item-toggle" @click="openAddMechanizationsModal()">
              <p>{{ $t('add-mechanizations') }}</p>
              <span class="new-content-data-item-toggle-circle">
                <span class="tms2">Y</span>
              </span>
            </div>
          </div> -->
        </header>

        <!-- WORKERS / MATERIALS / ACTIVITIES / MECHANIZATIONS -->
        <div
          class="new-content-data-row"
          v-if="viewLists(p)"
          :class="{ 'new-content-data-row-active': viewLists(p) }"
        >
          <div class="new-content-data-item">
            <div
              class="new-content-data-item-toggle mobile"
              @click="openAddWorkersModal(p)"
            >
              <p>{{ $t("report-users") }}</p>
              <span class="new-content-data-item-toggle-circle">
                <span class="tms">V</span>
              </span>
            </div>
            <table>
              <thead
                class="new-content-data-item-toggle desktop"
                @click="openAddWorkersModal(p)"
              >
                <tr>
                  <td class="ma-cell ma-cell-name">
                    <!-- :style="
                      !getUser.permissions.isSuperAdmin ? 'width: 80%' : ''
                    " -->
                    {{ $t("report-users") }}
                  </td>
                  <!--  <td class="ma-cell ma-cell-hours">
                    Изработени часове
                  </td>
                 <td
                    class="users-cell users-cell-nowrap desktop"
                    v-if="getUser.permissions.isSuperAdmin"
                  >
                    Коефициент
                  </td> -->
                  <td>
                    <span class="new-content-data-item-toggle-circle">
                      <span class="tms">V</span>
                    </span>
                  </td>
                </tr>
              </thead>
            </table>
            <div
              v-if="viewLists(p)"
              class="new-content-data-item-content new-content-data-item-content--no-padding-top"
            >
              <table>
                <tr v-if="p.workers.length < 1">
                  <td colspan="5" class="nothing-added">
                    {{ $t("no-reporters") }}
                  </td>
                </tr>

                <!-- REPORT USERS VAS -->
                <tr
                  class="first-tr first-tr--report-users"
                  v-if="reportUsersVas(p).length"
                >
                  <td class="ma-cell ma-cell-name">
                    <strong>{{ $t("users-vas") }}</strong>
                  </td>
                  <td></td>
                  <td class="ma-cell ma-cell-nowrap desktop">
                    <strong>Изработени часове</strong>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                <template v-for="(worker, i) in reportUsersVas(p)">
                  <tr
                    :class="{
                      'tr--border-top': i === 0,
                      'tr--disabled': worker.disabled,
                    }"
                    :key="`addedWorker-${worker._id}`"
                  >
                    <td class="ma-cell ma-cell-name">
                      <span class="tms" @click="removeWorker(p, worker)"
                        >b</span
                      >
                      <span class="tms tms--blue tms--role">y</span>
                      {{ worker.name }}
                    </td>
                    <td class="td--state-type">
                      <span
                        v-if="worker.state"
                        class="state-type"
                        :class="`state-type--${worker.state}`"
                        >{{ stateTypes[worker.state] }}</span
                      >
                    </td>
                    <td class="users-cell ma-cell-hours ma-cell-nowrap">
                      <ReportWorkerHourAndTag
                        v-if="!worker.disabled"
                        :report="report"
                        :worker="worker"
                        @changeWorker="changeWorker(p, worker)"
                      />
                    </td>
                  </tr>
                </template>
                <!-- REPORT USERS VAS -->

                <!-- REPORT GROUPS -->
                <tr
                  class="first-tr first-tr--report-users"
                  v-if="reportGroups(p).length"
                >
                  <td class="ma-cell ma-cell-name">
                    <strong>{{ $t("users-groups") }}</strong>
                  </td>
                  <td></td>
                  <td class="ma-cell ma-cell-nowrap desktop">
                    <strong>Изработени часове</strong>
                  </td>
                </tr>
                <template v-for="(group, i) in reportGroups(p)">
                  <tr
                    :class="{ 'tr--border-top': i !== 0 }"
                    :key="`addedWorker-${group._id}`"
                  >
                    <td
                      class="ma-cell ma-cell-name ma-cell-nowrap--bigger-font"
                    >
                      <span class="tms" @click="removeWorker(p, group, true)"
                        >b</span
                      >
                      <span class="tms tms--blue tms--role">0</span>
                      {{ group.name }}
                    </td>
                  </tr>
                  <template v-for="worker in group.users">
                    <tr
                      class="users-cell ma-cell-hours ma-cell-nowrap"
                      :class="{ 'tr--disabled': worker.disabled }"
                      :key="`worker-${worker._id}`"
                    >
                      <td
                        class="ma-cell ma-cell-name ma-cell-name--left-padding"
                      >
                        <span class="tms" @click="removeWorker(p, worker)"
                          >b</span
                        >
                        {{ worker.name }}
                      </td>
                      <td class="td--state-type">
                        <span
                          v-if="worker.state"
                          class="state-type"
                          :class="`state-type--${worker.state}`"
                          >{{ stateTypes[worker.state] }}</span
                        >
                      </td>
                      <td class="users-cell ma-cell-hours ma-cell-nowrap">
                        <ReportWorkerHourAndTag
                          v-if="!worker.disabled"
                          :report="report"
                          :worker="worker"
                          @changeWorker="changeWorker(p, worker)"
                        />
                      </td>
                    </tr>
                  </template>
                </template>
                <!-- REPORT GROUPS -->

                <!-- REPORT WORKER GROUPS -->
                <tr
                  class="first-tr first-tr--report-users"
                  v-if="reportWorkerGroups(p).length"
                >
                  <td class="ma-cell ma-cell-name">
                    <strong>{{ $t("users-workers-groups") }}</strong>
                  </td>
                  <td></td>
                  <td class="ma-cell ma-cell-nowrap desktop">
                    <strong>Изработени часове</strong>
                  </td>
                </tr>
                <template v-for="worker in reportWorkerGroups(p)">
                  <tr :key="`addedWorker-${worker._id}`">
                    <td
                      class="ma-cell ma-cell-name ma-cell-nowrap--bigger-font"
                    >
                      <span class="tms" @click="removeWorker(p, worker)"
                        >b</span
                      >
                      <span class="tms tms--brown tms--role">1</span>
                      <template v-if="worker.worker">
                        {{ `${worker.worker.name} - ${worker.name}` }}
                      </template>
                    </td>
                    <td class="td--state-type">
                      <span
                        v-if="worker.state"
                        class="state-type"
                        :class="`state-type--${worker.state}`"
                        >{{ stateTypes[worker.state] }}</span
                      >
                    </td>
                    <td class="users-cell ma-cell-hours ma-cell-nowrap">
                      <ReportWorkerHourAndTag
                        :report="report"
                        :worker="worker"
                        @changeWorker="changeWorker(p, worker)"
                      />
                    </td>
                  </tr>
                </template>
                <!-- REPORT WORKER GROUPS -->

                <template v-if="report.notReported">
                  <tr
                    v-for="worker in notReported"
                    :key="`notReportedWorker-${worker._id}`"
                  >
                    <td class="ma-cell ma-cell-name">
                      {{ worker.name }}
                    </td>
                    <td class="ma-cell ma-cell-nowrap desktop">
                      <button
                        class="add-to-report"
                        :class="{
                          'add-to-report--elsewhere': report.reportedElsewhere
                            ? report.reportedElsewhere.indexOf(worker._id) > -1
                            : false,
                        }"
                        :title="
                          report.reportedElsewhere
                            ? report.reportedElsewhere.indexOf(worker._id) > -1
                              ? 'Работникът е вече отчетен в друг отчет'
                              : 'Работникът не е отчитан другаде'
                            : ''
                        "
                        @click="addWorkerToReport(worker)"
                      >
                        <template
                          v-if="
                            report.reportedElsewhere
                              ? report.reportedElsewhere.indexOf(worker._id) >
                                -1
                              : false
                          "
                          ><svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16.205"
                            height="16.205"
                            viewBox="0 0 16.205 16.205"
                          >
                            <path
                              id="rel"
                              d="M9.13,13.992a4.846,4.846,0,0,0,1.37,3.383,10.881,10.881,0,0,1-2.018.182C4.729,17.557,2,15.893,2,13.483v-.463a1.945,1.945,0,0,1,1.945-1.945H10.1A4.84,4.84,0,0,0,9.13,13.992ZM8.482,2A3.889,3.889,0,1,1,4.593,5.889,3.889,3.889,0,0,1,8.482,2Zm1.3,11.992a4.213,4.213,0,1,0,4.213-4.213A4.213,4.213,0,0,0,9.778,13.992Zm3.467-2.645a2.593,2.593,0,0,1,3.015,1.228v-.527a.324.324,0,1,1,.648,0v1.3a.324.324,0,0,1-.324.324h-1.3a.324.324,0,0,1,0-.648h.471a1.945,1.945,0,0,0-3.143-.565A.324.324,0,1,1,12.158,12,2.592,2.592,0,0,1,13.246,11.347Zm1.492,5.29a2.593,2.593,0,0,1-3.015-1.228v.527a.324.324,0,1,1-.648,0v-1.3a.324.324,0,0,1,.324-.324h1.3a.324.324,0,0,1,0,.648h-.471a1.945,1.945,0,0,0,3.143.565.324.324,0,1,1,.458.458A2.592,2.592,0,0,1,14.738,16.637Z"
                              transform="translate(-2 -2)"
                              fill="#212121"
                            /></svg
                        ></template>
                        <template v-else>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17"
                            height="17"
                            viewBox="0 0 17 17"
                          >
                            <path
                              id="no"
                              d="M14.5,19A4.5,4.5,0,1,0,10,14.5,4.5,4.5,0,0,0,14.5,19Zm.624-2a.625.625,0,1,1-.625-.625A.625.625,0,0,1,15.124,17Zm1.229-3.552a1.513,1.513,0,0,1-.728,1.319l-.277.214c-.246.195-.328.3-.345.448l-.011.156A.5.5,0,0,1,14,15.5a1.48,1.48,0,0,1,.716-1.289L14.994,14c.288-.229.36-.342.36-.544a.884.884,0,0,0-.853-.95.853.853,0,0,0-.854.945.5.5,0,1,1-1,.01A1.849,1.849,0,0,1,14.5,11.5,1.882,1.882,0,0,1,16.353,13.453ZM9,2a4,4,0,1,0,4,4A4,4,0,0,0,9,2ZM4.009,11A2,2,0,0,0,2,13a4.352,4.352,0,0,0,2.135,3.8A9.142,9.142,0,0,0,9,18c.411,0,.816-.019,1.21-.057A5.5,5.5,0,0,1,10.257,11Z"
                              transform="translate(-2 -2)"
                              fill="#212121"
                            />
                          </svg>
                        </template>

                        Добави към отчета
                      </button>
                    </td>
                    <td
                      class="users-cell users-cell-nowrap"
                      v-if="getUser.permissions.isSuperAdmin"
                    ></td>
                  </tr>
                </template>
              </table>
            </div>
          </div>
          <!-- ACTIVITIES -->
          <div class="new-content-data-item">
            <!-- MOBILE -->
            <div
              class="new-content-data-item-toggle mobile"
              @click="openAddActivitiesModal(p)"
            >
              <p>{{ $t("activities") }}</p>
              <span class="new-content-data-item-toggle-circle">
                <span class="tms">U</span>
              </span>
            </div>
            <!-- DESKTOP -->
            <table>
              <thead
                class="new-content-data-item-toggle desktop"
                @click="openAddActivitiesModal(p)"
              >
                <tr>
                  <td
                    class="ma-cell ma-cell-name ma-cell-name--smaller"
                    :style="
                      !getUser.permissions.isSuperAdmin ? 'width: 75%' : ''
                    "
                  >
                    {{ $t("activities") }}
                  </td>
                  <!--  <td class="ma-cell desktop"></td>
                  <td class="ma-cell desktop">{{ $t('real') }}</td>
                  <td class="ma-cell desktop">{{ $t('planned') }}</td>
                  <td class="ma-cell desktop">{{ $t('difference') }}</td>
                  <td class="ma-cell desktop">{{ $t('new') }}</td>
                  <td v-if="getUser.permissions.isSuperAdmin || getUser.permissions.isAdmin" class="ma-cell">{{ $t('price-one') }}</td>
                  <td v-if="getUser.permissions.isSuperAdmin || getUser.permissions.isAdmin" class="ma-cell">{{ $t('price') }}</td> -->
                  <td>
                    <span class="new-content-data-item-toggle-circle">
                      <span class="tms">U</span>
                    </span>
                  </td>
                </tr>
              </thead>
            </table>
            <div v-if="viewLists(p)" class="new-content-data-item-content">
              <table>
                <tr class="first-tr">
                  <td class="ma-cell ma-cell-name">
                    <strong>{{ $t("activities") }}</strong>
                  </td>
                  <td class="ma-cell ma-cell-nowrap desktop">
                    <strong></strong>
                  </td>
                  <td class="ma-cell ma-cell-nowrap desktop">
                    <strong>{{ $t("real") }}</strong>
                  </td>
                  <td class="ma-cell ma-cell-nowrap desktop">
                    <strong>{{ $t("planned") }}</strong>
                  </td>
                  <td class="ma-cell ma-cell-nowrap desktop">
                    <strong>{{ $t("difference") }}</strong>
                  </td>
                  <td class="ma-cell ma-cell-nowrap desktop">
                    <strong>{{ $t("new") }}</strong>
                  </td>
                  <td class="ma-cell ma-cell-nowrap desktop">
                    <strong>Заработка</strong>
                  </td>
                  <td class="ma-cell ma-cell-nowrap desktop">
                    <strong>Сума заработка</strong>
                  </td>
                  <template
                    v-if="
                      getUser.permissions.isSuperAdmin ||
                      getUser.permissions.isAdmin
                    "
                  >
                    <td class="ma-cell ma-cell-nowrap desktop">
                      <strong>{{ $t("price-one") }}</strong>
                    </td>
                    <td class="ma-cell ma-cell-nowrap desktop">
                      <strong>{{ $t("price") }}</strong>
                    </td>
                  </template>
                </tr>
                <tr v-if="p.activities.length < 1">
                  <td colspan="10" class="nothing-added">
                    {{ $t("no-activities") }}
                  </td>
                </tr>
                <tr
                  v-for="(activity, index) in p.activities"
                  :key="`addedReportActivity-${index}`"
                >
                  <td
                    class="ma-cell ma-cell-name ma-cell-name--bigger allow-wrap"
                    :class="{ 'ma-cell-additional': activity.isAdditional }"
                  >
                    <!-- DELETE ACTIVITY -->
                    <span class="tms" @click="removeActivity(p, index)">b</span>
                    <span v-if="activity.isAdditional">⚡</span>
                    {{ activity.name }}
                  </td>
                  <!-- <td class="ma-cell ma-cell-nowrap">
                    <p
                      v-if="activity.worker"
                      class="add-worker-p"
                      @click="openAddWorkersModal('activities', index)"
                    >{{ activity.worker.name }}</p>
                    <p class="add-workers-toggle-wrapper" v-if="!activity.worker">
                      <span class="tms" @click="openAddWorkersModal('activities', index)">V</span>
                    </p>
                  </td> -->
                  <td class="ma-ce" :title="activity.note">
                    <input
                      class="ma-cell-input activity-note-input"
                      :class="{ empty: !activity.note }"
                      v-model="activity.note"
                      @keyup="changeActivity(p, index)"
                      type="text"
                      placeholder="Забележка"
                      maxlength="50"
                    />
                  </td>
                  <td class="ma-cell">
                    <p class="hours-status" :class="smrStatus(activity)">
                      {{ activity.totalUsed || 0 }}
                    </p>
                  </td>
                  <td class="ma-cell">{{ activity.plannedHours || 0 }}</td>
                  <td class="ma-cell">
                    {{ activity.difference || activity.plannedHours || 0 }}
                  </td>
                  <td class="ma-cell ma-cell-nowrap">
                    <input
                      class="ma-cell-input"
                      v-model="activity.quantity"
                      @keyup="changeActivity(p, index)"
                      :disabled="saving"
                      type="number"
                      min="0"
                    />
                    {{ activity.unit }}
                  </td>
                  <td class="ma-cell">
                    {{ (activity.earnings || 0).toFixed(2) }}
                    {{ $t("currency") }}
                  </td>
                  <td class="ma-cell">
                    {{
                      (
                        (+activity.earnings || 0) * (+activity.quantity || 0)
                      ).toFixed(2)
                    }}
                    {{ $t("currency") }}
                  </td>
                  <template
                    v-if="
                      getUser.permissions.isSuperAdmin ||
                      getUser.permissions.isAdmin
                    "
                  >
                    <td class="ma-cell ma-cell-nowrap">
                      <input
                        class="ma-cell-input"
                        v-model="activity.price"
                        @keyup="changeActivity(p, index)"
                        :disabled="saving"
                        type="number"
                        min="0"
                      />
                      {{ $t("currency") }}
                    </td>
                    <td class="ma-cell ma-cell-nowrap">
                      {{ (+activity.quantity * +activity.price).toFixed(2) }}
                      {{ $t("currency") }}
                    </td>
                  </template>
                </tr>
              </table>
            </div>
          </div>
          <!-- MATERIALS -->
          <div class="new-content-data-item">
            <!-- MOBILE -->
            <div
              class="new-content-data-item-toggle mobile"
              @click="openAddMaterialsModal(p)"
            >
              <p>{{ $t("Materials") }}</p>
              <span class="new-content-data-item-toggle-circle">
                <span class="tms">T</span>
              </span>
            </div>
            <!-- DESKTOP -->
            <table>
              <thead
                class="new-content-data-item-toggle desktop"
                @click="openAddMaterialsModal(p)"
              >
                <tr>
                  <td
                    class="ma-cell ma-cell-name ma-cell-name--big"
                    :style="
                      !getUser.permissions.isSuperAdmin ? 'width: 75%' : ''
                    "
                  >
                    {{ $t("Materials") }}
                  </td>
                  <!-- <td class="ma-cell">{{ $t('quantity') }}</td>
                  <td v-if="getUser.permissions.isSuperAdmin || getUser.permissions.isAdmin" class="ma-cell">{{ $t('price-one') }}</td>
                  <td v-if="getUser.permissions.isSuperAdmin || getUser.permissions.isAdmin" class="ma-cell">{{ $t('price') }}</td> -->
                  <td>
                    <span class="new-content-data-item-toggle-circle">
                      <span class="tms">T</span>
                    </span>
                  </td>
                </tr>
              </thead>
            </table>
            <!-- LIST -->
            <div v-if="viewLists(p)" class="new-content-data-item-content">
              <table>
                <tbody>
                  <tr class="first-tr">
                    <td class="ma-cell ma-cell-name">
                      <strong>{{ $t("Materials") }}</strong>
                    </td>
                    <td class="ma-cell ma-cell-nowrap desktop">
                      <strong>{{ $t("quantity") }}</strong>
                    </td>
                    <template
                      v-if="
                        getUser.permissions.isSuperAdmin ||
                        getUser.permissions.isAdmin
                      "
                    >
                      <td class="ma-cell ma-cell-nowrap desktop">
                        <strong>{{ $t("price-one") }}</strong>
                      </td>
                      <td class="ma-cell ma-cell-nowrap desktop">
                        <strong>{{ $t("price") }}</strong>
                      </td>
                    </template>
                  </tr>
                  <tr v-if="p.materials.length < 1">
                    <td colspan="5" class="nothing-added">
                      {{ $t("no-materials") }}
                    </td>
                  </tr>
                  <tr
                    v-for="(material, index) in p.materials"
                    :key="`addedReportMaterial-${index}-${material.name}`"
                  >
                    <td
                      class="ma-cell ma-cell-name"
                      :class="{ 'ma-cell-additional': material.isAdditional }"
                    >
                      <!-- DELETE MATERIAL -->
                      <span class="tms" @click="removeMaterial(p, index)"
                        >b</span
                      >
                      <span v-if="material.isAdditional">⚡</span>
                      {{ material.name }}
                    </td>
                    <!-- <td class="ma-cell ma-cell-nowrap">
                      <p
                        v-if="material.worker"
                        class="add-worker-p"
                        @click="openAddWorkersModal('materials', index)"
                      >{{ material.worker.name }}</p>
                      <p class="add-workers-toggle-wrapper" v-if="!material.worker">
                        <span class="tms" @click="openAddWorkersModal('materials', index)">V</span>
                      </p>
                    </td> -->
                    <td class="ma-cell ma-cell-nowrap">
                      <input
                        class="ma-cell-input"
                        v-model="material.quantity"
                        @keyup="changeMaterial(p, index)"
                        type="number"
                        :disabled="saving"
                        min="0"
                      />
                      {{ material.unit }}
                    </td>
                    <template
                      v-if="
                        getUser.permissions.isSuperAdmin ||
                        getUser.permissions.isAdmin
                      "
                    >
                      <td class="ma-cell ma-cell-nowrap">
                        <input
                          class="ma-cell-input"
                          v-model="material.price"
                          @keyup="changeMaterial(p, index)"
                          type="number"
                          :disabled="saving"
                          min="0"
                        />
                        {{ $t("currency") }}
                      </td>
                      <td class="ma-cell ma-cell-nowrap">
                        {{ (+material.quantity * +material.price).toFixed(2) }}
                        {{ $t("currency") }}
                      </td>
                    </template>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="invalid-report-wrap total-price">
            <p>Общо заработки:</p>
            <p>{{ partTotalSumEarnings(p) }} {{ $t("currency") }}</p>
            <template
              v-if="
                getUser.permissions.isSuperAdmin || getUser.permissions.isAdmin
              "
            >
              <p>{{ $t("total-price-report") }}:</p>
              <p>{{ partTotalSum(p) }} {{ $t("currency") }}</p>
            </template>
          </div>
        </div>
      </div>
    </template>

    <button class="add-new-part" @click="addNewPart()">
      <span class="tms">L</span>
      <strong>Добави част</strong>
    </button>

    <p class="add-part-info">
      Добавете част и планираните, но неотчетени работници в предишните части ще
      се добавят автоматично
    </p>

    <div class="invalid-report-wrap total-price totals">
      <p>Общо заработки отчет:</p>
      <p>{{ getPartsTotals().earnings }} {{ $t("currency") }}</p>
      <template
        v-if="getUser.permissions.isSuperAdmin || getUser.permissions.isAdmin"
      >
        <p>Общо отчет:</p>
        <p>{{ getPartsTotals().total }} {{ $t("currency") }}</p>
      </template>
    </div>

    <div class="new-wrapper leave-padding" v-if="$route.name === 'editReport'">
      <div class="new-content-data-row">
        <div class="invalid-report-wrap">
          <p>
            <strong>{{ $t("mark-report-as-invalid") }}</strong>
            - {{ $t("mark-report-as-invalid-2") }}.
          </p>
          <div class="switch-wrapper">
            <div class="switch-container">
              <label class="switch">
                <input
                  type="checkbox"
                  v-model="report.isInvalid"
                  @change="reportChanged(), (report.locked = !report.isInvalid)"
                  :disabled="!allowSave"
                />
                <span class="slider"></span>
              </label>
            </div>
            <label
              class="switch-label"
              @click="
                (report.isInvalid = true), (report.locked = !report.isInvalid)
              "
            >
              <img
                v-if="report.isInvalid"
                class="flag"
                src="../assets/img/flag_yes.svg"
                alt="Invalid"
              />
              <img
                v-else
                class="flag"
                src="../assets/img/flag_no.svg"
                alt="Valid"
              />
              {{ $t("invalid-report") }}
            </label>
          </div>
        </div>
      </div>
    </div>
    <!-- ADD MATERIALS/ACTIVITIES/MECHANIZATIONS MODALS -->
    <transition name="fade">
      <AddUsersModal
        v-if="isAddUsersModalOpened"
        :isCommingFromReport="true"
        :allUsers="true"
        :date="report.date"
        :usersType="'workers'"
        :incomingUsers="isAddUsersModalOpened.workers"
      />
    </transition>
    <transition name="fade">
      <!-- :projectId="report.project._id" -->
      <AddMaterialsModal
        v-if="isAddMaterialsModalOpened"
        :isCommingFromReport="true"
        :companyId="report.company._id"
        :objectId="report.object._id"
        :partId="isAddMaterialsModalOpened.part._id"
        :incomingMaterials="selectedPart.materials"
        @getMaterialsAgain="getMaterials"
      />
    </transition>
    <transition name="fade">
      <!-- :projectId="report.project._id" -->
      <AddActivitiesModal
        v-if="isAddActivitiesModalOpened"
        :isCommingFromReport="true"
        :companyId="report.company._id"
        :objectId="report.object._id"
        :partId="isAddActivitiesModalOpened.part._id"
        :incomingActivities="selectedPart.activities"
        :selectedActivities="isAddActivitiesModalOpened.activities"
      />
    </transition>
    <transition name="fade">
      <!-- :projectId="report.project._id" -->
      <AddMechanizationsModal
        v-if="isAddMechanizationsModalOpened"
        :isCommingFromReport="true"
        :companyId="report.company._id"
        :objectId="report.object._id"
        :partId="report.part._id"
        :incomingMechanizations="selectedPart.mechanizations"
      />
    </transition>
    <transition name="fade">
      <UnsavedChangesModal v-if="isUnsavedChangesModalOpened" />
    </transition>
    <transition name="fade">
      <ElsewhereModal
        v-if="reportedElsewhereForConfirmation.length"
        :workers="reportedElsewhereForConfirmation"
        @confirmed="reportedElsewhereConfirmed"
        @declined="reportedElsewhereDeclined"
      />
    </transition>
  </div>
</template>

<script>
import hours from "./mixins/hours.js";
import AddUsersModal from "./shared/AddUsersModal";
import AddMaterialsModal from "./shared/AddMaterialsModal";
import AddActivitiesModal from "./shared/AddActivitiesModal";
import AddMechanizationsModal from "./shared/AddMechanizationsModal";
import UnsavedChangesModal from "./shared/UnsavedChangesModal";
import { mapGetters } from "vuex";
import WorktimeTag from "./shared/WorktimeTag";
import SelectHour from "./shared/SelectHour";
import ElsewhereModal from "./shared/ElsewhereModal";
import ReportWorkerHourAndTag from "./shared/ReportWorkerHourAndTag";
import Datepicker from "vuejs-datepicker";
import { bg } from "vuejs-datepicker/dist/locale";
import { format } from "date-fns";
import log from "./mixins/log.js";
import axios from "axios";

export default {
  components: {
    AddUsersModal: AddUsersModal,
    AddMaterialsModal: AddMaterialsModal,
    AddActivitiesModal: AddActivitiesModal,
    AddMechanizationsModal: AddMechanizationsModal,
    UnsavedChangesModal: UnsavedChangesModal,
    Datepicker: Datepicker,
    SelectHour,
    WorktimeTag,
    ElsewhereModal,
    ReportWorkerHourAndTag,
  },
  mixins: [hours, log],
  watch: {
    "report.date"(to) {
      // if (!(to.getTime() < this.today.getTime())) {
      //   this.report.date = new Date();
      //   this.$snotify.error("Не можете да създавате отчети с бъдеща дата!");
      // }

      this.formatedDate = format(new Date(this.report.date), 'dd/MM/yyyy');
    },
    // ,
    // "report.company"(to) {
    //   if(this.report)
    //   this.company = this.report.company;
    //   // console.log(this.company);
    // },
    // "report.project"(to) {
    //   if(this.report)
    //   this.project = this.report.project;
    // },
    // "report.object"(to) {
    //   if(this.report)
    //   this.object = this.report.object;
    // },
    // "report.part"(to) {
    //   if(this.report)
    //   this.part = this.report.part;
    // }
  },
  data() {
    return {
      // Vars for select v-model
      company: "",
      project: "",
      object: "",
      part: "",
      isReportChanged: false,
      setStatuses: false,
      // Vars for date picker
      bg: bg,
      formatedDate: "",
      today: undefined,
      planningToEdit: undefined,
      // А boolean for every dropdown in the template
      openedDropdown: [false, false, false, false, false, false, false],
      // A boolean for the modal for workers selection
      isAddUsersModalOpened: false,
      isAddMaterialsModalOpened: false,
      isAddActivitiesModalOpened: false,
      isAddMechanizationsModalOpened: false,
      isUnsavedChangesModalOpened: false,
      saving: false,
      isComingFromOutside: null,
      // SEARCH
      searchCompanies: "",
      // searchProjects: "",
      searchObjects: "",
      searchParts: "",
      removedFromPlanningMats: [],
      // The main company object
      companies: [],
      latestCompanies: [{ company: { _id: "", companyName: "" } }],
      // projects: [],
      objects: [],
      parts: [],
      stateTypes: {
        paid: "Платен отпуск",
        unpaid: "Неплатен отпуск",
        illness: "Отпуск по болест",
        compensation: "Самоотлъчка",
        unreported: "Неотчетен служител",
        reported: "Отчетен",
        plannedElse: "Планиран и за друг обект",
        reportedElse: "Отчетен и за друг обект",
      },
      reportedElsewhereForConfirmation: [],
      // selectedObject: undefined,
      selectedPart: undefined,
      selectedWorkerType: undefined,
      selectedWorkerIndex: null,
      allowSave: true,
      // The main report object
      report: {
        date: undefined,
        startHour: "08:30",
        endHour: "17:00",
        overtime: false,
        createdBy: {
          _id: "",
          name: "",
        },
        company: {
          _id: "",
          companyName: "",
        },
        // project: {
        //   _id: "",
        //   projectName: "",
        // },
        object: {
          _id: "",
          objectName: "",
        },
        parts: [],
        part: {
          _id: "",
          partName: "",
        },
        isInvalid: false,
        materials: [],
        activities: [],
        // mechanizations: [],
        workers: [],
      },
      fromPlanning: {},
    };
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters([
      "getUser",
      // ...
    ]),
    canLockOrUnlock() {
      // const same = this.$route.name === "editReport" && !this.saving;
      const same = this.$route.name === "editReport";
      if (this.report.locked) {
        return same && this.getUser.permissions.isSuperAdmin;
      } else {
        return (
          same &&
          (this.getUser.permissions.isSuperAdmin ||
            this.getUser.permissions.isAdmin ||
            (this.getUser.permissions.isReporter &&
              this.report.createdBy._id === this.getUser._id))
        );
      }
    },
    canSaveReport() {
      if (!this.report.locked) {
        return (
          !this.report._id ||
          this.getUser.permissions.isSuperAdmin ||
          this.getUser.permissions.isAdmin ||
          (this.getUser.permissions.isReporter &&
            this.report.createdBy._id === this.getUser._id)
        );
      }

      return false;
    },
  },
  methods: {
    // Open dropdown. Depends on index (hard coded in template)
    openDropdown(i) {
      this.$set(this.openedDropdown, i, true);
    },
    // Close dropdown. Depends on index (hard coded in template)
    closeDropdown(i) {
      setTimeout(() => {
        this.$set(this.openedDropdown, i, false);
      }, 100);
    },
    // SELECTING
    // 1 - SELECT COMPANY BY ID
    selectCompany(company) {
      // this.resetSelectedProject();
      this.resetSelectedObject();
      this.report.company = company;
    },
    // 2 - SELECT THE INDEX OF A 'PROJECT' INSIDE COMPANY
    // selectProject(project) {
    //   this.resetSelectedObject();
    //   this.report.project = project;
    // },
    // 3 - SELECT THE INDEX OF AN 'OBJECT' INSIDE A PROJECT
    selectObject(object) {
      this.resetSelectedPart();
      this.report.object = object;
      // this.getSelectedObject(object._id);
    },
    // 4 - SELECT THE INDEX OF A 'PART' INSIDE AN OBJECT
    selectPart(part, selected) {
      part.part = selected;
      part.search = "";
      this.getSelectedPart(selected._id);
      this.autoAddWorkers(part);
      this.autoAddMaterials(part);
    },
    async autoAddMaterials(part) {
      this.isAddMaterialsModalOpened = part;
      let arr = this.fromPlanning.materials.concat(
        this.removedFromPlanningMats
      );
      this.handleMaterial(arr, true);
      this.fromPlanning.materials = [];
    },
    async autoAddWorkers(part) {
      const content = {};

      content.workerGroups = this.fromPlanning.groups
        .filter((g) => g.isWorkerGroup)
        .map((t) => t._id);
      content.groups = this.fromPlanning.groups.filter((g) => !g.isWorkerGroup);
      content.users = this.fromPlanning.users;

      let workers = [];

      // add workers to report
      for (let tag of ["users", "workerGroups", "groups"]) {
        if (content[tag].length) {
          for (let w of content[tag]) {
            let url = `${process.env.VUE_APP_BASE_URI}/auth/users/`;

            if (tag === "groups") {
              for (let user of w.users) {
                url = `${process.env.VUE_APP_BASE_URI}/auth/users/${user._id}`;

                let u = await axios.get(url);
                u = u.data;
                u.new = true;
                u.isFromGroup = true;
                workers.push(u);
              }
            } else if (tag === "users") {
              url += `${w._id}`;
            } else if (tag === "workerGroups") {
              url = `${process.env.VUE_APP_BASE_URI}/group/${w}`;
            }

            if (tag !== "groups") {
              let u = await axios.get(url);
              u = u.data;
              u.new = true;
              if (tag === "workerGroups") u.isWorkerGroup = true;
              workers.push(u);
            }
          }
        }
      }

      // could be better but not enough time now
      const alreadyAdded = [];

      for (let p of this.report.parts) {
        alreadyAdded.push(...p.workers.map((w) => w._id));
      }

      // cleanup
      workers = workers.filter((w) => alreadyAdded.indexOf(w._id) < 0);

      this.handleWorker(workers, part);
    },
    // RESET SELECTED AND EVERYTHING NESTED INSIDE ON FOCUS
    resetSelectedCompany() {
      this.report.company = {
        _id: "",
        companyName: "",
      };
      this.searchCompanies = "";
      this.company = "";
      this.resetSelectedObject();
    },
    // resetSelectedProject() {
    //   this.projects = [];
    //   this.searchProjects = "";
    //   this.report.project = {
    //     _id: "",
    //     projectName: "",
    //   };
    //   this.project = "";
    //   this.resetSelectedObject();
    // },
    resetSelectedObject() {
      this.objects = [];
      this.searchObjects = "";
      this.report.object = {
        _id: "",
        objectName: "",
      };
      // this.selectedObject = undefined;
      this.report.materials = [];
      this.report.activities = [];
      this.report.mechanizations = [];
      this.object = "";
      this.resetSelectedPart();
    },
    resetSelectedPart() {
      this.reportChanged();
      this.parts = [];
      this.searchParts = "";
      this.selectedPart = undefined;
      this.report.part = {
        _id: "",
        partName: "",
      };
      this.part = "";
    },
    // FILTERED RESULTS WHEN SEARCHING
    filteredCompanies() {
      if (this.companies.length) {
        return this.companies.filter((c) => {
          return c.companyName
            .toLowerCase()
            .includes(this.searchCompanies.toLowerCase());
        });
      }
    },
    // filteredProjects() {
    //   if (this.report.company._id && this.projects.length) {
    //     return this.projects.filter((p) => {
    //       return p.projectName
    //         .toLowerCase()
    //         .includes(this.searchProjects.toLowerCase());
    //     });
    //   }
    // },
    filteredObjects() {
      if (this.objects.length) {
        return this.objects.filter((o) => {
          return o.objectName
            .toLowerCase()
            .includes(this.searchObjects.toLowerCase());
        });
      }
    },
    filteredParts(search = "") {
      if (this.report.object._id && this.parts.length) {
        return this.parts.filter((p) => {
          return p.partName.toLowerCase().includes(search.toLowerCase());
        });
      }
    },
    // We have a selected materials, activities OR mechanizations at least and change styles in template
    viewLists(p) {
      return (
        p.workers.length || p.materials.length || p.activities.length
        // ||
        // this.report.mechanizations.length
      );
    },
    hoursToNum(str) {
      const [hours, minutes] = str.split(":");
      const num = parseInt(hours + minutes, 10);
      return num;
    },
    areWorkerHoursOverlapping(w, partIndex) {
      for (let i = 0; i < this.report.parts.length; i++) {
        let p = this.report.parts[i];
        if (p.workers.length) {
          for (let wr of p.workers) {
            // check is users are in more than one part and if their workign hours are oeverlapping
            if (wr._id.toString() === w._id.toString() && i !== partIndex) {
              // check if hours overlap
              if (
                this.hoursToNum(wr.startHour) <= this.hoursToNum(w.startHour) &&
                this.hoursToNum(wr.endHour) >= this.hoursToNum(w.endHour)
              ) {
                return true;
              }
            }
          }
        }
      }
    },
    // If we get the 'saveWorkersModal' event, we assign the workers we receive to the report
    handleWorker(workers, p) {
      // this.report[this.selectedWorkerType][this.selectedWorkerIndex].worker = w;
      const part = p ? p : this.isAddUsersModalOpened;

      part.workers = [];

      for (let w of workers) {
        if (!w.startHour && !w.endHour) {
          this.$set(w, "startHour", "08:00");
          this.$set(w, "endHour", "17:00");
          this.$set(w, "new", true);
        }
        part.workers.push(w);
      }
      this.closeAddWorkersModal();
      this.reportChanged();
      this.checkForReportedElsewhereWorkers();
      this.setDisabledUsers();
    },
    checkForReportedElsewhereWorkers() {
      // TODO: FIX FOR NEW STRUCTURE
      if (!this.report.reportedElsewhere) return;

      for (let part of this.report.parts) {
        for (let w of part.workers) {
          if (w.new && !w.elsewhereConfirmed) {
            if (this.report.reportedElsewhere.indexOf(w._id) > -1) {
              this.reportedElsewhereForConfirmation.push(w);
            }
          }
        }
      }
    },
    reportedElsewhereConfirmed(id) {
      const i = this.report.workers.map((w) => w._id).indexOf(id);

      if (i > -1) {
        this.$set(this.report.workers[i], "elsewhereConfirmed", true);
      }

      const j = this.reportedElsewhereForConfirmation
        .map((w) => w._id)
        .indexOf(id);
      if (j > -1) this.reportedElsewhereForConfirmation.splice(j, 1);
    },
    reportedElsewhereDeclined(id) {
      const i = this.report.workers.map((w) => w._id).indexOf(id);

      if (i > -1) {
        this.report.workers.splice(i, 1);
      }

      const j = this.reportedElsewhereForConfirmation
        .map((w) => w._id)
        .indexOf(id);
      if (j > -1) this.reportedElsewhereForConfirmation.splice(j, 1);
    },
    handleMaterial(mats, keepQnt) {
      if (this.isAddMaterialsModalOpened) {
        for (let m of mats) {
          if (!keepQnt) m.quantity = 0;
          m.worker = null;
          this.isAddMaterialsModalOpened.materials.push(m);
        }
        // this.sortMaterials(this.isAddMaterialsModalOpened);
        this.closeAddMaterialsModal();
        this.reportChanged();
      }
    },
    handleActivity(activities) {
      // this.isAddActivitiesModalOpened.activities = [];
      for (let a of activities) {
        // "old" is for activities that are already in the report
        if (a.old) continue;
        if (!a.old) {
          a.quantity = 0;
          a.worker = null;
          a.note = "";
        }
        this.isAddActivitiesModalOpened.activities.push(a);
        this.getPartSmrTotals(a);
      }
      this.closeAddActivitiesModal();
      this.reportChanged();
    },
    handleMechanization(m) {
      m.quantity = 0;
      m.worker = null;
      this.report.mechanizations.push(m);
      this.closeAddMechanizationsModal();
      this.reportChanged();
    },
    openAddWorkersModal(part, t, i) {
      if (this.allowSave) {
        this.selectedWorkerType = t;
        this.selectedWorkerIndex = i;
        this.isAddUsersModalOpened = part;
      }
    },
    async openAddMaterialsModal(part) {
      if (this.allowSave) {
        await this.getSelectedPart(part.part._id);
        this.isAddMaterialsModalOpened = part;
      }
    },
    async openAddActivitiesModal(part) {
      if (this.allowSave) {
        await this.getSelectedPart(part.part._id);
        this.isAddActivitiesModalOpened = part;
      }
    },
    openAddMechanizationsModal() {
      if (this.allowSave) {
        this.isAddMechanizationsModalOpened = true;
      }
    },
    // Close the workers modal
    closeAddWorkersModal() {
      this.isAddUsersModalOpened = false;
      this.selectedWorkerIndex = null;
      this.selectedWorkerType = null;
    },
    closeAddMaterialsModal() {
      this.isAddMaterialsModalOpened = false;
    },
    closeAddActivitiesModal() {
      this.isAddActivitiesModalOpened = false;
    },
    closeAddMechanizationsModal() {
      this.isAddMechanizationsModalOpened = false;
    },
    // JUST FOR THE CASE OF REACTIVITY TO WORK AND NOT USE forceUpdate()
    changeMaterial(part, i) {
      this.$set(part.materials, i, part.materials[i]);
      this.reportChanged();
    },
    changeActivity(part, i) {
      this.$set(part.activities, i, part.activities[i]);
      this.reportChanged();
    },
    changeMechanization(i) {
      this.$set(this.report.mechanizations, i, this.report.mechanizations[i]);
      this.reportChanged();
    },
    changeWorker(part, w) {
      let i = part.workers.indexOf(w);

      if (i !== -1) {
        this.$set(part.workers, i, part.workers[i]);
        this.reportChanged();
      }
    },
    removeMaterial(part, i) {
      this.removedFromPlanningMats.push(part.materials[i]);
      part.materials.splice(i, 1);
    },
    removeActivity(part, i) {
      part.activities.splice(i, 1);
    },
    removeWorker(part, w, isGroup) {
      if (isGroup) {
        for (let gu of w.users) {
          let i = part.workers.indexOf(gu);
          if (i !== -1) part.workers.splice(i, 1);
        }
      } else {
        let i = part.workers.indexOf(w);
        if (i !== -1) part.workers.splice(i, 1);
      }
    },
    removeMechanization(i) {
      this.report.mechanizations.splice(i, 1);
    },
    addNewPart(part) {
      const p = {
        part: {
          _id: "",
          partName: "",
        },
        workers: [],
        activities: [],
        materials: [],
      };

      if (part) this.selectPart(p, part);

      this.report.parts.push(p);
    },
    removePart(i) {
      if (confirm("Сигурни ли сте, че искате да изтриете частта?")) {
        this.report.parts.splice(i, 1);
      }
    },
    reportUsersVas(part) {
      return part.workers.filter((w) => !w.isWorkerGroup && !w.isFromGroup);
    },
    reportGroups(part) {
      let groupIds = [];
      let groups = [];

      part.workers.forEach((w) => {
        if (w.isFromGroup) {
          if (w.group._id && !groupIds.includes(w.group._id)) {
            groupIds.push(w.group._id);
          }
        }
      });

      for (let gId of groupIds) {
        let g = { _id: gId, users: [] };
        part.workers.forEach((w) => {
          if (w.isFromGroup && w.group._id === gId) {
            g.name = w.group.name;
            g.users.push(w);
          }
        });

        groups.push(g);
      }

      return groups;
    },
    reportWorkerGroups(part) {
      return part.workers.filter((w) => w.isWorkerGroup);
    },
    // GET ALL COMPANIES REQUEST
    getCompanies() {
      this.companies = [];
      let id = this.getUser._id;
      let requestUrl = `${process.env.VUE_APP_BASE_URI}/company/reporters/companies/${id}`;
      this.$http
        .get(requestUrl)
        .then((response) => {
          this.companies = response.data;
        })
        .catch((error) => console.log(error));
    },
    // GET LATEST REPORTED COMPANIES
    getLatestUsedCompanies() {
      const id = this.getUser._id;
      const url = `${process.env.VUE_APP_BASE_URI}/report/limited/${id}/5`;
      this.$http
        .get(url)
        .then((response) => {
          this.latestCompanies = response.data;
        })
        .catch((error) => console.log(error));
    },
    // GET ALL VISIBLE PROJECTS INSIDE THE SELECTED COMPANY
    // getProjects() {
    //   this.projects = [];
    //   if (this.report.company._id.length) {
    //     let id = this.getUser._id;
    //     let requestUrl = `${process.env.VUE_APP_BASE_URI}/company/reporters/projects/${this.report.company._id}/${id}`;
    //     this.$http
    //       .get(requestUrl)
    //       .then((response) => {
    //         this.projects = response.data;
    //       })
    //       .catch((error) => console.log(error));
    //   }
    // },
    // GET ALL VISIBLE OBJECTS INSIDE THE SELECTED PROJECT
    getObjects() {
      this.objects = [];
      // if (this.report.project._id.length) {
      if (this.report.company._id.length) {
        let id = this.getUser._id;
        // let requestUrl = `${process.env.VUE_APP_BASE_URI}/company/reporters/objects/${this.report.company._id}/${this.report.object._id}/${id}`;
        let requestUrl = `${process.env.VUE_APP_BASE_URI}/company/reporters/objects/${this.report.company._id}/${id}`;
        this.$http
          .get(requestUrl)
          .then((response) => {
            this.objects = response.data;
          })
          .catch((error) => console.log(error));
      }
    },
    getParts(autoSelectIfOnlyOne) {
      this.parts = [];
      if (this.report.object._id.length) {
        let id = this.getUser._id;
        let requestUrl = `${process.env.VUE_APP_BASE_URI}/company/reporters/parts/${this.report.company._id}/${this.report.object._id}/${id}`;
        return this.$http
          .get(requestUrl)
          .then((response) => {
            this.parts = response.data;

            if (autoSelectIfOnlyOne && this.parts.length === 1) {
              this.addNewPart(this.parts[0]);
            }
          })
          .catch((error) => console.log(error));
      }
    },
    // GET ALL VISIBLE PARTS INSIDE THE SELECTED OBJECT
    // getParts() {
    //   this.parts = [];
    //   if (this.report.project._id.length) {
    //     let id = this.getUser._id;
    //     let requestUrl = `${process.env.VUE_APP_BASE_URI}/company/reporters/parts/${this.report.company._id}/${this.report.project._id}/${this.report.object._id}/${id}`;
    //     this.$http
    //       .get(requestUrl)
    //       .then((response) => {
    //         this.parts = response.data;
    //       })
    //       .catch((error) => console.log(error));
    //   }
    // },
    // GET SPECIFIC PART BY ID REQUEST
    // getSelectedObject(id) {
    //   this.selectedObject = undefined;
    //   let url = `${process.env.VUE_APP_BASE_URI}/company/part/${id}`;
    //   return this.$http
    //     .get(url)
    //     .then((response) => {
    //       this.selectedObject = response.data[0];
    //     })
    //     .catch((error) => console.log(error));
    // },
    getSelectedPart(id) {
      this.selectedPart = undefined;
      let url = `${process.env.VUE_APP_BASE_URI}/company/part/${id}`;
      return this.$http
        .get(url)
        .then((response) => {
          this.selectedPart = response.data[0];
        })
        .catch((error) => console.log(error));
    },
    getMaterials() {
      let url = `${process.env.VUE_APP_BASE_URI}/company/part/${this.selectedPart._id}`;
      return this.$http
        .get(url)
        .then((response) => {
          this.selectedPart.materials = response.data[0].materials;
        })
        .catch((error) => console.log(error));
    },
    getActivities() {
      let url = `${process.env.VUE_APP_BASE_URI}/company/part/${this.selectedPart._id}`;
      return this.$http
        .get(url)
        .then((response) => {
          this.selectedPart.activities = response.data[0].activities;
        })
        .catch((error) => console.log(error));
    },
    getMechanizations() {
      let url = `${process.env.VUE_APP_BASE_URI}/company/part/${this.selectedPart._id}`;
      return this.$http
        .get(url)
        .then((response) => {
          this.selectedPart.mechanizations = response.data[0].mechanizations;
        })
        .catch((error) => console.log(error));
    },
    getFromPlanning() {
      this.fromPlanning = {};
      let url = `${process.env.VUE_APP_BASE_URI}/planning/single/${this.report.fromPlanning}`;
      return this.$http.get(url).then((response) => {
        this.fromPlanning = response.data;
      });
    },
    // GET SPECIFIC REPORT
    getReport(id) {
      let url = `${process.env.VUE_APP_BASE_URI}/report/${id}`;
      this.$http.get(url).then(async (response) => {
        this.setStatuses = true;
        // this.getSelectedPart(response.data.part._id).then(() => {
        this.report = response.data;
        this.getPartSmrTotals();
        this.getFromPlanning();
        this.isComingFromOutside = true; // goes to reports/own after closing
        this.report.date = new Date(response.data.date);
        let getReportPlan = await this.$http.get(`${process.env.VUE_APP_BASE_URI}/planning/report/${response.data._id}`)
        if(getReportPlan.data) this.planningToEdit = getReportPlan.data._id

        for (let p of this.report.parts) {
          if (p.workers.length) {
            this.handleWorker(p.workers, p);
          }
        }

        if (this.report.isInvalid) {
          if (
            !this.getUser.permissions.isSuperAdmin &&
            !this.getUser.permissions.isAdmin
          ) {
            this.allowSave = false;
            this.$snotify.warning(this.$t("invalid-reports-warning-message"));
          }
        }
        setTimeout(() => {
          this.setStatuses = false;
        }, 1000);
      });
      // })
      // .catch((error) => console.log(error));
    },
    isValid() {
      if (!this.report.company._id.length) {
        this.$snotify.error(this.$t("not-selected-company"));
        return false;
      }
      if (!this.report.object._id.length) {
        this.$snotify.error(this.$t("not-selected-site"));
        return false;
      }

      if (!this.report.parts.length) {
        this.$snotify.error("Трябва да добавите поне една част");
        return false;
      }

      for (let i = 0; i < this.report.parts.length; i++) {
        let part = this.report.parts[i];

        if (!part.part._id.length) {
          this.$snotify.error("Трябва да изберете всяка една част");
          return false;
        }

        if (part.workers.length) {
          for (let w of part.workers) {
            if (this.areWorkerHoursOverlapping(w, i)) {
              this.$snotify.error(
                `Моля променете изработените часове на ${w.name} в част ${part.part.partName}`
              );
              return false;
            }

            if (!w.startHour || !w.endHour) {
              this.$snotify.error(
                "Всеки работник трябва да има избрани начален и краен час"
              );
              return false;
            }
          }

          part.workers = part.workers.filter((w) => !w.disabled);
          this.$snotify.warning(
            "Работниците в отпуск и болничен, няма да се виждат в отчета след запис."
          );
          if (!part.workers.length) {
            this.$snotify.error(
              "След премахването на работниците в отпуск или болничен, няма останали работници в отчета."
            );
            return false;
          }
        }
      }

      return true;
    },
    removeTempIds() {
      for (let p of this.report.parts) {
        if (p.materials.length) {
          p.materials.map((m) => {
            if (m.tempId) {
              delete m._id;
            }
          });
        }
        if (p.activities.length) {
          p.activities.map((a) => {
            if (a.tempId) {
              delete a._id;
            }
          });
        }
        // if (this.report.mechanizations.length) {
        //   this.report.mechanizations.map(a => {
        //     if (a.tempId) {
        //       delete a._id;
        //     }
        //   });
        // }
      }
    },
    editReportCompany() {
      let url = `${process.env.VUE_APP_BASE_URI}/company/${this.report.company._id}`;

      this.$http.get(url).then((response) => {
        const company = response.data;
        // get index of selected project
        const indexOfObject = company.objects.findIndex(
          (p) => p._id === this.report.object._id
        );

        for (let p of this.report.parts) {
          // get index of selected object
          const indexOfPart = company.objects[indexOfObject].parts.findIndex(
            (o) => o._id === p.part._id
          );

          p.activities.forEach((ra) => {
            company.objects[indexOfObject].parts[
              indexOfPart
            ].activities.forEach((a) => {
              if (ra.name == a.name && a.price === "0" && a.isAdditional) {
                a.price = ra.price;
                a.quantity = ra.quantity;
              }
            });
          });
        }

        // make the post request
        let url = `${process.env.VUE_APP_BASE_URI}/company/${company._id}`;

        this.$http
          .put(url, company)
          .then(() => {})
          .catch((error) => {
            console.log(error);
            this.$snotify.error(this.$t("something-went-wrong"));
          });
      });
    },
    validateReport() {
      let url = `${process.env.VUE_APP_BASE_URI}/report/validate-report`;
      return this.$http.post(url, this.report);
    },
    removeDisabledUsers() {
      if (this.report.workers.length) {
        this.report.workers = this.report.workers.filter((w) => !w.disabled);
      }
    },
    // POST NEW REPORT
    postReport() {
      this.saving = true;
      if (this.isValid()) {
        this.report.createdAt = new Date();
        this.validateReport().then((a) => {
          if (
            a.data.errors ||
            a.data.exists.length ||
            a.data.existsAbsences.length
          ) {
            if (a.data.errors) {
              this.$snotify.error("Нещо се обърка! Моля опитайте отново.");
              this.saving = false;
            }
            if (a.data.exists.length) {
              for (let i = 0; i < a.data.exists.length; i++) {
                this.$snotify.error(
                  `${a.data.exists[i].parts.workers.name} е вече добавен към друг отчет в диапазона ${a.data.exists[i].parts.workers.startHour} - ${a.data.exists[i].parts.workers.endHour}`
                );
              }
              this.saving = false;
            } else if (a.data.existsAbsences.length) {
              for (let a of a.data.existsAbsences) {
                let formatFrom = format(new Date(a.from), 'dd/MM/yyyy');
                let formatTo = format(new Date(a.to), 'dd/MM/yyyy');

                this.$snotify.error(
                  `${a.user.name} е в отпуск за датите ${formatFrom} - ${formatTo}`
                );
              }
              this.saving = false;
            }
          } else {
            this.removeTempIds();
            this.report.createdBy._id = this.getUser._id;
            this.report.createdBy.name = this.getUser.name;

            for (let p of this.report.parts) {
              for (let w of p.workers) {
                if (w.group ? !w.group._id : false) {
                  w.group = undefined;
                }
              }
            }

            let url = `${process.env.VUE_APP_BASE_URI}/report`;
            this.$http
              .post(url, this.report)
              .then((a) => {
                if (a.data.errors) {
                  this.$snotify.error("Нещо се обърка! Моля опитайте отново.");
                  this.saving = false;
                } else {
                  this.editReportCompany();
                  this.$snotify.success("Вашият отчет беше създаден успешно!");
                  this.newLog(
                    "newReport",
                    `обект - ${this.report.object.objectName}`
                  );
                  this.isReportChanged = false;
                  // this.saving = false;
                  // this.cancelReport();
                  console.log(a);
                  this.getReport(a.data._id);
                  this.$router.push(`/reports/edit/${a.data._id}`);
                }

                if (this.planningToEdit) this.updatePlan(a.data._id);
              })
              .catch((error) => {
                console.log(error.response);
                this.$snotify.error("Нещо се обърка! Моля опитайте отново.");
                this.saving = false;
              });
          }
        });
      } else {
        this.saving = false;
      }
    },
    // EDIT REPORT
    editReport() {
      if (this.isValid()) {
        this.saving = true;

        this.validateReport().then((a) => {
          if (
            a.data.errors ||
            a.data.exists.length ||
            a.data.existsAbsences.length
          ) {
            if (a.data.errors) {
              this.$snotify.error("Нещо се обърка! Моля опитайте отново.");
              this.saving = false;
            }
            if (a.data.exists.length) {
              for (let i = 0; i < a.data.exists.length; i++) {
                this.$snotify.error(
                  `${a.data.exists[i].parts.workers.name} е вече добавен към друг отчет в диапазона ${a.data.exists[i].parts.workers.startHour} - ${a.data.exists[i].parts.workers.endHour}`
                );
              }
              this.saving = false;
            } else if (a.data.existsAbsences.length) {
              for (let a of a.data.existsAbsences) {
                let formatFrom = format(new Date(a.from), 'dd/MM/yyyy');
                let formatTo = format(new Date(a.to), 'dd/MM/yyyy');

                this.$snotify.error(
                  `${a.user.name} е в отпуск за датите ${formatFrom} - ${formatTo}`
                );
              }
              this.saving = false;
            }
          } else {
            this.removeTempIds();
            let url = `${process.env.VUE_APP_BASE_URI}/report/${this.$route.params.id}`;
            this.$http
              .put(url, this.report)
              .then(() => {})
              .catch((error) => {
                console.log(error);
                this.$snotify.error(this.$t("something-went-wrong"));
              })
              .then(() => {
                this.editReportCompany();
                this.$snotify.success(this.$t("success-changes"));
                if (this.planningToEdit) this.updatePlan(this.report._id);
                this.isReportChanged = false;
                this.newLog(
                  "editReport",
                  `${this.$t("site").toLowerCase()} - ${
                    this.report.object.objectName
                  }`
                );
                // this.cancelReport();
                this.getPartSmrTotals();
              });
          }
        });
      }
    },
    updatePlan(report) {
      const url = `${process.env.VUE_APP_BASE_URI}/planning/${this.planningToEdit}/report/${report}`;

      this.$http
        .put(url)
        .then(() => {})
        .catch((error) => {
          console.log(error.response);
          this.$snotify.error(this.$t("something-went-wrong"));
        });
    },
    // Cancel report and go back 1 route behind
    cancelReport() {
      if (this.$route.query.back) {
        this.$router.go(-1);
      } else if (this.isComingFromOutside) {
        this.$router.push("/reports/own");
      } else {
        this.$router.go(-1);
      }
    },
    // async sortMaterials(p) {
    //   let part = await this.$http.get(
    //     `${process.env.VUE_APP_BASE_URI}/company/part/${p.part._id}`
    //   );
    //   let materials = part.data[0].materials;

    //   if (materials.length) {
    //     let sortedMaterials = materials.filter((m) =>
    //       p.materials.some((rm) => {
    //         m.quantity = rm.quantity;
    //         m.price = rm.price;
    //         if (rm._id.toString() === m._id.toString()) {
    //           return rm;
    //         }
    //       })
    //     );

    //     if (sortedMaterials.length) p.materials = sortedMaterials;
    //   }
    // },
    partTotalSumEarnings(part) {
      let sum = 0;
      for (let msm of part.activities) {
        sum += (+msm.quantity || 0) * (+msm.earnings || 0);
      }
      return sum.toFixed(2);
    },
    partTotalSum(part) {
      let sum = 0;
      for (let tag of ["materials", "activities"]) {
        for (let msm of part[tag]) {
          sum += msm.quantity * +msm.price;
        }
      }
      return sum.toFixed(2);
    },
    getPartsTotals() {
      let earnings = 0;
      let total = 0;

      for (let p of this.report.parts) {
        for (let tag of ["materials", "activities"]) {
          for (let msm of p[tag]) {
            total += msm.quantity * +msm.price;
            if (tag === "activities")
              earnings += (+msm.quantity || 0) * (+msm.earnings || 0);
          }
        }
      }

      earnings = earnings.toFixed(2);
      total = total.toFixed(2);
      return { earnings, total };
    },
    getPartSmrTotals(a) {
      // TODO MAKE IT WORK FOR THE NEW STRUCTURE
      for (let p of this.report.parts) {
        let part = p.part._id;
        let object = this.report.object._id;
        if (part && object) {
          let url = `${process.env.VUE_APP_BASE_URI}/report/totalSmr/${
            this.report.company._id
          }/${object}/${part}?fromReport=${a ? a._id : true}`;
          this.$http
            .get(url)
            .then((res) => {
              if (res.data.length) {
                let filteredActivities = [];
                for (let r of res.data) {
                  for (let a of p.activities) {
                    if (r._id.toString() === a._id.toString()) {
                      r.name = a.name
                      r.earnings = a.earnings
                      r.note = a.note;
                      r.price = a.price;
                      r.quantity = a.quantity;
                      filteredActivities.push(r);
                    }
                  }
                }

                p.activities = filteredActivities;
              }
            })
            .catch((error) => console.log(error));
        }
      }
    },
    smrStatus(a) {
      if (Number(a.totalUsed) === Number(a.plannedHours))
        return "hours-status--green";
      if (Number(a.totalUsed) > Number(a.plannedHours))
        return "hours-status--orange";
      else return "hours-status--red";
    },
    reportChanged() {
      if (!this.isReportChanged && !this.setStatuses) {
        this.isReportChanged = true;
        this.saving = false;
      }
    },
    // checkForDuplicateWorkers() {
    //   if (this.report.parts && this.report.parts.length) {
    //     let added = [];
    //     let hasDuplicates = false;

    //     for (let p of this.report.parts) {
    //       if (p.workers && p.workers.length) {
    //         for (let u of p.workers) {
    //           if (!u.disabled) {
    //             if (added.includes(u._id)) {
    //               this.$snotify.error(
    //                 `${u.name} се дублира в част ${p.part.partName}`
    //               );
    //               hasDuplicates = true;
    //             } else {
    //               added.push(u._id);
    //             }
    //           }
    //         }
    //       }
    //     }

    //     return hasDuplicates;
    //   }

    //   return false;
    // },
    save() {
      // if(this.checkForDuplicateWorkers()) return

      // if (this.canSaveReport) {
      if (this.$route.name === "newReport") {
        this.postReport();
      } else if (this.$route.name === "editReport") {
        this.editReport();
      }
      // } else {
      //   this.$snotify.warning("Не можете да запишете заключен отчет!");
      // }
    },
    checkForUnsavedData(next) {
      this.isUnsavedChangesModalOpened = true;
      this.$once("closeUnsavedChangesModal", (answer) => {
        // confirm
        if (answer) {
          next(false);
          this.save();
        }
        // decline
        else {
          next();
        }
        this.isUnsavedChangesModalOpened = false;
        this.isReportChanged = false;
      });
    },
    async setDisabledUsers() {
      // TODO
      //eslint-disable-next-line
      for (let part of this.report.parts) {
        if (part.workers.length) {
          for (let u of part.workers) {
            const url = `${process.env.VUE_APP_BASE_URI}/absence/validate`;
            const absence = {
              group: u.group ? u.group._id : null,
              user: u._id,
              from: this.report.date,
              to: this.report.date,
              objectId: this.report.object._id,
            };

            let isAbsent = await this.$http.post(url, absence);
            if (isAbsent.data.state) {
              this.$set(u, "state", isAbsent.data.state);
              if (isAbsent.data.state === "reportedElse" && u.new) {
                this.$set(u, "startHour", null);
                this.$set(u, "endHour", null);
              }

              // disable user only when user is absent or in vacation
              if (
                isAbsent.data.state !== "plannedElse" &&
                isAbsent.data.state !== "reportedElse" &&
                isAbsent.data.state !== "reported"
              ) {
                this.$set(u, "disabled", true);
              }
            }

            if (u.group && this.isCommingFromGroup) {
              if (
                (this.groupId && u.group._id !== this.groupId) || // EDIT GROUP USERS if group user is in another group
                (u.group._id && !this.groupId) // NEW GROUP when he already has group
              )
                this.$set(u, "isDisabled", true);
            }
          }
        }
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.isComingFromOutside = from.name ? false : true;
    });
  },
  mounted() {
    this.today = new Date();
    this.today.setHours(23, 59, 59, 999);

    this.getCompanies();
    this.getLatestUsedCompanies();
    if (this.$route.name === "newReport") {
      this.report.date = new Date();
    } else if (this.$route.name === "editReport") {
      this.getReport(this.$route.params.id);
    }
    // Start listening for children's events
    this.$on("saveAddUsersModal", this.handleWorker);
    this.$on("saveAddMaterialsModal", this.handleMaterial);
    this.$on("saveAddActivitiesModal", this.handleActivity);
    this.$on("saveAddMechanizationsModal", this.handleMechanization);
    this.$on("getActivitiesAgain", this.getActivities);
    // this.$on('getMechanizationsAgain', this.getMechanizations);
    // Close listening for children's events
    this.$on("closeAddUsersModal", this.closeAddWorkersModal);
    this.$on("closeAddMaterialsModal", this.closeAddMaterialsModal);
    this.$on("closeAddActivitiesModal", this.closeAddActivitiesModal);
    this.$on("closeAddMechanizationsModal", this.closeAddMechanizationsModal);

    this.setStatuses = true;
    setTimeout(async () => {

      if (this.$route.query.planId) {
        this.report.fromPlanning = this.$route.query.planId;
        await this.getFromPlanning();

        if (this.fromPlanning) {
          let plan = this.fromPlanning;

          plan.workerGroups = plan.groups
            .filter((g) => g.isWorkerGroup)
            .map((t) => t._id);
          plan.groups = plan.groups.filter((g) => !g.isWorkerGroup);
          this.planningToEdit = plan._id;
          this.report.date = new Date(plan.date);
          this.selectCompany(plan.company);
          this.selectObject(plan.object);
          await this.getParts(true);

          // removes route query
          this.$router.replace({ query: null });
        }
      }

      // if (this.$route.query.content) {
      //   let content = JSON.parse(this.$route.query.content);

      //   this.planningToEdit = content.planning;
      //   this.report.fromPlanning = content.planning;
      //   await this.getFromPlanning();

      //   this.report.date = new Date(content.date);
      //   this.selectCompany(content.company);
      //   this.selectObject(content.object);
      //   await this.getParts(true);
      //   // this.selectPart(content.part);

      //   // removes route query
      //   this.$router.replace({ query: null });
      // }
    }, 500);

    setTimeout(() => {
      this.setStatuses = false;
    }, 1000);
  },
  beforeRouteLeave(to, from, next) {
    if (this.isReportChanged && !this.report.locked) {
      this.checkForUnsavedData(next);
    } else {
      next();
    }
  },
  destroyed() {
    // Stop listening
    this.$off("saveAddUsersModal");
    this.$off("saveAddMaterialsModal");
    this.$off("saveAddActivitiesModal");
    this.$off("saveAddMechanizationsModal");
    this.$off("getActivitiesAgain");
    this.$off("getMechanizationsAgain");

    this.$off("closeAddUsersModal");
    this.$off("closeAddMaterialsModal");
    this.$off("closeAddActivitiesModal");
    this.$off("closeAddMechanizationsModal");
  },
};
</script>

<style lang="scss" scoped>
.locked-state {
  align-items: center;
  color: #187413;
  display: flex;
  font-size: 20px;
  justify-content: center;
  &.locked-state--locked {
    color: #bc0000;
  }

  .tms {
    cursor: pointer;
    font-size: 30px;
    user-select: none;
  }

  &.locked-state--text-only {
    flex-direction: column;

    span {
      font-size: 12px;
      line-height: 12px;
    }
  }
}
.new-report {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px 40px;
}
.report-header {
  align-items: center;
  display: flex;
  height: 36px;
  justify-content: space-between;
  .btns {
    flex-basis: 0;
    flex-grow: 1;
    justify-content: flex-end;

    .btn {
      margin: 0;
    }
  }
}
.heads {
  align-items: center;
  display: flex;
  justify-content: flex-start;
  flex-basis: 0;
  flex-grow: 1;
}
.title {
  margin-left: 0.5em;
}
.italic {
  font-style: italic;
}
.italic::placeholder {
  font-style: italic;
}
.italic::-moz-placeholder {
  font-style: italic;
}
.italic:-moz-placeholder {
  font-style: italic;
}
.italic:-ms-input-placeholder {
  font-style: italic;
}
.italic::-webkit-input-placeholder {
  font-style: italic;
}
/* .desktop { */
/* display: flex; */
/* } */
.mobile {
  display: none;
}
.new-content-data-item-toggle-circle .tms2 {
  font-size: 18px;
}
.btn.new-content-data-item-toggle-circle {
  margin-left: 0;
}
.date {
  cursor: pointer;
}
.indicator-display {
  align-items: center;
  border: 1px solid #cecece;
  display: flex;
  height: 40px;
  justify-content: space-between;
  padding: 5px 15px 5px 40px;
}
.indicator-inactive {
  background-color: #c4c4c4;
}
.new-wrapper {
  flex-direction: column;
  margin: 0;
  &:not(.leave-padding) {
    padding-top: 0;
    padding-bottom: 0;
  }
  &:nth-child(2) {
    background: #fff;

    .new-input input {
      background: #f4f4f4;
    }
  }

  .new-content-data-row,
  .new-content-data-row-active {
    margin-top: 0;
  }
}
.new-wrapper-invalid {
  background-color: #fff8f8;
}
.invalid-report-wrap {
  align-items: center;
  background-color: #fff;
  border: 1px solid #cecece;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  padding: 10px;
  width: 100%;
}
.invalid-report-wrap.total-price {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 10px;
  justify-content: flex-end;
  width: 100%;

  &.totals {
    background: #7a9fb8;
    border-radius: 4px;
    color: #ffffff;
  }
}
.invalid-report-wrap .switch-wrapper {
  align-items: center;
  display: flex;
}
.invalid-report-wrap .switch {
  margin: 0;
}
.invalid-report-wrap .switch-label {
  align-items: center;
  display: flex;
}
.invalid-report-wrap .slider {
  background-color: #c4c4c4;
}
.invalid-report-wrap input:checked + .slider {
  background-color: #9f0510;
}
.invalid-report-wrap .flag {
  height: 24px;
  margin: 0 8px;
}
.invalid-report-wrap > p {
  padding-right: 20px;
}
.title .flag {
  height: 24px;
  vertical-align: baseline;
  margin: 0 5px;
}
.title span {
  display: inline-flex;
  align-items: center;
}
.first-tr td {
  padding-bottom: 10px;
}
.first-tr--report-users {
  position: relative;
  z-index: 1;
}
.first-tr--report-users:after {
  background-color: #0d5683;
  content: "";
  height: 25px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: calc(100% + 23px);
  z-index: -1;
}
.first-tr--report-users td {
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;
  color: white;
  padding: 0 20px;
  z-index: 1;
}
.first-tr--report-users:first-of-type td {
  border-top: 0 solid transparent;
  border-bottom: 0 solid transparent;
}
.tr--border-top td {
  border-top: 20px solid transparent;
}
.tr--disabled td:not(.td--state-type) {
  opacity: 0.5;
}
.add-worker-p {
  cursor: pointer;
}
.add-workers-toggle-wrapper {
  text-align: center;
}
.add-workers-toggle-wrapper .tms {
  align-items: center;
  background-color: #0058bc;
  border-radius: 50%;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  font-size: 12px;
  justify-content: center;
  height: 20px;
  -webkit-transition: background-color 0.3s;
  -moz-transition: background-color 0.3s;
  -ms-transition: background-color 0.3s;
  -o-transition: background-color 0.3s;
  transition: background-color 0.3s;
  width: 20px;
}
.add-workers-toggle-wrapper .tms:hover {
  background-color: #0058bc;
}
/* .new-content-data-item-content table {
  border-collapse: collapse;
} */
/* .new-content-data-item-content tr td {
  padding: 5px 10px;
} */
/* .new-content-data-item-content tr:nth-child(even) td { */
/* border-bottom: 1px solid #CECECE; */
/* } */
/* Responsive */
.new-content-data-row {
  border: none;
  width: 100%;
  padding: 0;
}

.part-header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  gap: 20px;
  width: 100%;

  .new-input-wrapper {
    width: calc(33.33% - 13.33px);
  }

  .buttons {
    display: flex;
    gap: 10px;
    button {
      align-items: center;
      background: #deecf9;
      border: 0;
      border-radius: 4px;
      color: #005a9e;
      display: flex;
      font-size: 16px;
      gap: 5px;
      justify-content: center;
      transition: opacity 0.3s;
      white-space: nowrap;
      width: 200px;

      &:not(:disabled) {
        cursor: pointer;
      }

      &:disabled,
      &:hover {
        opacity: 0.8;
      }
    }
  }
}
.add-part-info {
  color: #373737;
  font-size: 16px;
  opacity: 0.5;
  text-align: center;
}
.add-new-part {
  align-items: center;
  background: #0058bc;
  border: 0;
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
  display: flex;
  gap: 5px;
  height: 33px;
  justify-content: center;
  outline: none;
  text-align: center;
  transition: opacity 0.3s;
  width: 100%;
  span {
    font-size: 20px;
  }
  strong {
    font-size: 16px;
  }
  &:hover {
    opacity: 0.8;
  }
}

.activity-note-input {
  height: 100%;
  margin: 0;
  min-height: 22px;
  padding: 0 10px;
  text-align: center;
  width: 200px;
  &.empty {
    &::placeholder {
      color: #c84630;
    }
  }
}

.new-content-data-item-content {
  overflow: auto;
}

@media screen and (max-width: 1280px) {
  .indicator-display {
    padding-right: 2px;
  }
  .indicator-display .indicators {
    display: inline-flex;
  }
  .indicator-display .worktime-indicator {
    height: 34px;
    margin: 0 2px;
    width: 14px;
  }
  .indicator-display .worktime-indicator span {
    transform: rotate(-90deg);
    font-size: 9px;
    white-space: nowrap;
    font-weight: 700;
  }
}
@media screen and (max-width: 1000px) {
  .mobile {
    display: flex;
    width: 100%;
    flex-direction: row;
  }
  .new-report {
    padding: 10px 15px;
  }
  .new-content-inputs.desktop,
  .desktop {
    display: none;
  }
  .new-content {
    width: 100%;
  }
  .new-content-inputs.mobile {
    display: flex;
    flex-direction: column;
  }
  .new-input-wrapper {
    width: 100%;
  }
  /* .new-input.mobile.drop {
    padding: 15px;
  } */
  .new-content-inputs {
    flex-direction: column;
  }
  .date-irv-wrapper {
    display: flex;
    width: 100%;
  }
  .datepicker-dropdown-active {
    width: 210%;
  }
  .start-end-wrapper {
    display: flex;
    width: 100%;
  }
  .report-header {
    .title {
      font-size: 14px;
    }
    .heads {
      flex-grow: 1;
    }
    > .locked-state {
      font-size: 14px;
      margin: 0 10px;
      text-align: right;
    }
    // justify-content: flex-start;
  }
  .new-content-inputs {
    gap: 0;
  }
  .new-content-data-item-toggle.mobile {
    text-align: center;
    /* flex-direction: column; */
    height: auto;
    padding-bottom: 0.6em;
  }
  .new-content-data-item-small {
    width: calc(33.33% - 13.33px);
  }
  .new-content-data-item-small .new-content-data-item-toggle.mobile {
    flex-direction: column;
  }
  .new-content-data-item-toggle.mobile p {
    margin-top: 0.6em;
    margin-bottom: 0.6em;
    margin-right: 0px;
  }
  .new-content-data-item-content .ma-cell-name {
    white-space: nowrap;
  }
  .new-content-data-item-content .ma-cell-nowrap {
    white-space: nowrap;
  }
  .new-content-data-item-content .users-cell p {
    display: flex;
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    justify-content: flex-end;
    margin-right: 0px;
  }
  .btns.mobile {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;
    margin-top: 1em;
    margin-bottom: 1em;
    .btn {
      margin: 0;
    }

    .btn-unlock--wrapper {
      display: flex;
      flex-basis: 100%;
      justify-content: center;
      width: 100%;
    }
  }
  .date,
  .indicator-display {
    height: 51px;
  }
  .label {
    color: #373737;
    font-size: 11px;
    font-weight: 700;
  }

  .new-wrapper {
    gap: 10px;
  }
  .part-header {
    flex-direction: column;
    gap: 0;
    .new-input-wrapper {
      width: 100%;
    }
    .buttons {
      flex-direction: column;
      width: 100%;
      button {
        width: 100%;
      }
    }
  }
  .invalid-report-wrap.total-price {
    font-size: 14px;
  }
}
@media screen and (max-width: 600px) {
  .invalid-report-wrap {
    flex-direction: column;

    &:not(.total-price) {
      > p {
        padding: 0 0 15px;
        text-align: center;
      }
    }

    &.total-price {
      > p {
        padding: 0;
        &:nth-child(3) {
          margin-top: 1rem;
        }
      }
    }
  }
}
</style>
